import React from "react";
import ReactDOM from "react-dom/client";
import AppRouter from "./AppRouter";
import "./index.css";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./components/Toast";
import { initSfx } from "./services/sfx";
import ErrorBoundary from "./components/ErrorBoundary";
import { GlobalErrorOverlay } from "./components/GlobalErrorOverlay";

// Global handler for unhandled promise rejections
// Prevents app crashes from AbortErrors when components unmount or during auth redirects
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  const errorName = error?.name || '';
  const errorMessage = String(error?.message || '').toLowerCase();

  if (
    errorName === 'AbortError' ||
    errorMessage.includes('aborted') ||
    errorMessage.includes('signal is aborted without reason') ||
    errorMessage.includes('abort')
  ) {
    event.preventDefault();
    return;
  }

  console.error('[UnhandledRejection]', error?.message || error);
});

initSfx();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <GlobalErrorOverlay>
      <ErrorBoundary>
        <AuthProvider>
          <ToastProvider>
            <AppRouter />
          </ToastProvider>
        </AuthProvider>
      </ErrorBoundary>
    </GlobalErrorOverlay>
  </React.StrictMode>
);
